import { render, staticRenderFns } from "./leadsPerStatus.vue?vue&type=template&id=1624da50"
import script from "./leadsPerStatus.vue?vue&type=script&lang=js"
export * from "./leadsPerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports